import { render, staticRenderFns } from "./_integralRecord.vue?vue&type=template&id=2accb3f6&scoped=true"
import script from "./_integralRecord.vue?vue&type=script&lang=js"
export * from "./_integralRecord.vue?vue&type=script&lang=js"
import style0 from "./_integralRecord.vue?vue&type=style&index=0&id=2accb3f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2accb3f6",
  null
  
)

export default component.exports